import { setSmallScreenWarningModal } from '../../store/general/slice';
import { SmallScreenIllustration } from '../../assets/illustrations';
import { useDispatch } from '../../store/store';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function SmallScreenWarning() {
    const dispatch = useDispatch();

    return (
        <Modal size='sm' childClassName={styles.wrapper}>
            <SmallScreenIllustration />
            <p className={styles.text}>
                Please use a wider screen device<br /> for a better experience.
            </p>
            <div className={styles.actions}>
                <Button
                    type='Primary'
                    text='Continue anyway'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setSmallScreenWarningModal(false))}
                />
            </div>
        </Modal >
    )
}
